<template>
    <div>
        Register!
      
        <form @submit.prevent="submit">
            <div class="form-group">
                <label for="name" class="col-form-label">Name</label>
                <input type="text" name="name" id="name" v-model="form.name" class="form-control">
                <div class="alert alert-danger" v-if="errors.validation && errors.validation.name">
                    {{ errors.validation.name[0] }}
                </div>
            </div>
            <div class="form-group">
                <label for="email" class="col-form-label">Email</label>
                <input type="text" name="email" id="email" v-model="form.email" class="form-control">
                <div class="alert alert-danger" v-if="errors.validation && errors.validation.email">
                    {{ errors.validation.email[0] }}
                </div>
            </div>
            <div class="form-group">
                <label for="password" class="col-form-label">Password</label>
                <input type="password" name="password" id="password" v-model="form.password" class="form-control">
                <div class="alert alert-danger" v-if="errors.validation && errors.validation.password">
                    {{ errors.validation.password[0] }}
                </div>
            </div>
            <div class="form-group">
                <label for="password2" class="col-form-label">Password confirm</label>
                <input type="password" name="password2" id="password2" v-model="form.password2" class="form-control">
            </div>
            <div class="form-group">
                <button type="submit" class="btn btn-primary">
                    Register
                </button>
            </div>
            <div class="alert alert-danger" v-if="errors.register">
                {{ errors.register }}
            </div>
            <div class="alert alert-success" v-if="success">
                {{ success }}
            </div>

        </form>
    </div>
</template>

<script>

import axios from 'axios'
export default {
    name: 'register',
    components: {
        //
    },
    data() {
        return {
            form: {
                name: '',
                email: '',
                password: '',
                password2: '',
            },
            errors: {register: '', validation: {}},
            success: ''
        }
    },
    methods: {
        async submit() {
            this.errors.validation = {}
            this.errors.register = ''
            this.success = ''
            if (this.form.password != this.form.password2) {
                this.errors.validation = { password: ['Пароли не совпадают!'] }
                return
            }
            try {
                let response = await axios.post('register', this.form);
                if (response.status == 200) {
                    this.success = 'Пользователь (email: ' + this.form.email + ') зарегистрирован!'
                }
            }
            catch (e) {
                if (e.response.status == 422) {
                    this.errors.validation = e.response.data.errors
                }
                else if (e.response.status == 520) {
                    this.errors.register = "Ошибка при регистрации пользователя."
                }
                else {
                    this.errors.register = "Неизвестная ошибка при регистрации пользователя."
                }
            }
        },
    }
}
</script>